// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"8da5dc00","77":"6b7cd92e","119":"f21c2942","156":"d4533242","365":"85c5ad79","645":"3dd62968","936":"7c8b90db","975":"f801ce68"}[chunkId] + ".chunk.js";
};